import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../shared.module';
import { EditComponent } from './components/edit/edit.component';
import { AuthorizedVisitComponent } from './pages/authorized-visit/authorized-visit.component';
import { ListComponent } from './pages/list/list.component';
import { NestedTableComponent } from './components/nested-table/nested-table.component';

const routes: Routes = [
  {
    path: '',
    component: ListComponent,
    data: { animation: 'isLeft' },
  },
  {
    path: 'authorized-visit/:visitId',
    component: AuthorizedVisitComponent,
    data: { animation: 'isLeft' },
  },
];

@NgModule({
  declarations: [ListComponent, EditComponent, NestedTableComponent, AuthorizedVisitComponent],
  imports: [CommonModule, RouterModule.forChild(routes), SharedModule],
})
export class VisitVehiclesModule {}
